import { render, staticRenderFns } from "./levelmanege.vue?vue&type=template&id=08df79d8&scoped=true&"
import script from "./levelmanege.vue?vue&type=script&lang=js&"
export * from "./levelmanege.vue?vue&type=script&lang=js&"
import style0 from "./levelmanege.vue?vue&type=style&index=0&id=08df79d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df79d8",
  null
  
)

export default component.exports